.section {
  margin-top: 2rem;
}

.card {
  background-color: white;
  margin-bottom: 3rem;
}
